import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import Select from '../../../components/forms/Select'
import { MODELS_TYPES } from './ModelConstants'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { StyledFieldSet } from 'components/StyledElements'
import { DOCUMENTS_EXTENSIONS } from 'components/file/constant/FileConstants'

const PopupAddModel = ({
    openDialog,
    stationType,
    changeStationType = () => {},
    onUploadFile = () => {},
    addModel = () => {},
    closeDialog = () => {},
}) => (
    <Dialog
        fullWidth
        maxWidth='lg'
        open={openDialog}
    >
        <DefaultDialogTitle
            title={i18n.addFile}
            onClose={closeDialog}
        />
        <DialogContent>
            <StyledFieldSet>
                <Grid container>
                    <Grid size={6} sx={{ paddingTop: '10px' }}>
                        <Select
                            label={i18n.modelTypeSelection}
                            value={stationType}
                            onChange={value => changeStationType(value)}
                            keyLabel='name'
                            keyValue='stationType'
                            options={MODELS_TYPES}
                            data-cy='station_type'
                        />
                    </Grid>
                    <Grid size={12}>
                        <div className='file-field input-field'>
                            <div className='btn'>
                                <span>{ i18n.fileToDownload }</span>
                                <input
                                    accept={DOCUMENTS_EXTENSIONS}
                                    id='uploadFile'
                                    type='file'
                                    multiple
                                    onChange={value => onUploadFile(value)}
                                    data-cy='upload_file'
                                />
                            </div>
                            <div className='file-path-wrapper'>
                                <input className='file-path validate' type='text' />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </StyledFieldSet>
        </DialogContent>
        <DialogActions>
            <Button onClick={addModel} variant='contained' color='primary' data-cy='add_model_button'>
                {i18n.addModel}
            </Button>
        </DialogActions>
    </Dialog>
)

PopupAddModel.propTypes = {
    openDialog: PropTypes.bool,
    stationType: PropTypes.string,
    changeStationType: PropTypes.func,
    onUploadFile: PropTypes.func,
    addModel: PropTypes.func,
    closeDialog: PropTypes.func,
}

export default PopupAddModel